<template>
    <div>
        <div style="margin:0 -12px;">
            <div class="luna-header-box">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-4">
                            <br>
                            <a href="/event/home">
                                <svg style="height:14px;width:14px;fill:#999;margin-top: -10px;">
                                    <use xlink:href="/images/<.svg#page_left"></use>
                                </svg>
                            </a>
                        </div>
                        <div class="col px-0 text-center">
                            <div style="padding-top:20px; ">
                                <b>イベント管理</b>
                            </div>
                        </div>
                        <div class="col-4">
                        </div>
                    </div>
                </div>
            </div>
            <div class="wrap">
                <div class="container" style="margin-top:60px;">
                    <div v-if="event.is_read_only" class="alert alert-secondary" role="status">
                        このイベントは非公開となっており、編集・再公開・削除はできません。
                        再度開催する場合は、新しいイベントを作成してください。
                    </div>
                    <div class="row">
                        <div class="col">
                            <div style="padding:0 10px;">
                                <div>
                                    <small> サムネイル画像 </small>
                                </div>
                                <div>
                                    <div>
                                        <img :src="initialImage + '?' + im" class="img-fluid">
                                    </div>
                                    <br>
                                    <small>変更する場合はこちらから設定してください</small>
                                    <croppa v-model="myCroppa" :width="250" :height="140" placeholder=""
                                        :placeholder-font-size="0" :disabled="false" :prevent-white-space="false"
                                        :show-remove-button="true" accept=".jpeg,.jpg,.png"
                                        @file-type-mismatch="onFileTypeMismatch">
                                        <img slot="placeholder" src="/images/Group13419_1.png" height="200" width="200">
                                    </croppa>
                                    <div class="text-end" style="width:250px;padding-bottom:10px;">
                                        <button type="button" class="btn btn-luna" style="font-size: 18px;"
                                            @click="myCroppa.rotate()"><i class="bi bi-arrow-clockwise"></i>
                                        </button>
                                    </div>
                                    <div style="font-size:12px;color:#999;">
                                        ■ 推奨サイズ　500px × 280px 以上<br>
                                        ■ 形式はjpg/pngが対象です。<br>
                                        ■ その他ここに注意文言が入ります。
                                    </div>
                                </div>
                                <br>
                                <div>
                                    <small> イベント名 </small>
                                </div>
                                <input type="text" class="luna-form-control" v-model="thumbnail" placeholder="入力する" />
                                <br />
                                <div>
                                    <small> 主催名（イベント詳細ページにて表示されます） </small>
                                </div>
                                <input type="text" class="luna-form-control" v-model="organizer" placeholder="入力する" />
                                <br />
                                <div>
                                    <small> 開催日時 </small>
                                </div>
                                <input type="date" class="luna-form-control" v-model="event_at" placeholder="" />
                                <br />
                                <v-select name="event_type" :options="event_types" v-model="event_type"
                                    placeholder="選択してください" :onchange="setEventTypeVal()">
                                </v-select>
                                <div v-show="event_type_val > 0">
                                    <br>
                                    <div class="row">
                                        <div class="col-2 text-end" style="padding-top:15px;">
                                            1部
                                        </div>
                                        <div class="col-2 text-center" style="padding-top:15px;">
                                            開場
                                        </div>
                                        <div class="col">
                                            <input type="time" class="luna-form-control" v-model="event_at_open_1" />
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-2 text-end" style="padding-top:15px;">

                                        </div>
                                        <div class="col-2 text-center" style="padding-top:15px;">
                                            開演
                                        </div>
                                        <div class="col">
                                            <input type="time" class="luna-form-control" v-model="event_at_from_1" />
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-2 text-end" style="padding-top:15px;">

                                        </div>
                                        <div class="col-2 text-center" style="padding-top:15px;">
                                            閉演
                                        </div>
                                        <div class="col">
                                            <input type="time" class="luna-form-control" v-model="event_at_to_1" />
                                        </div>
                                    </div>
                                </div>
                                <div v-show="event_type_val > 1">
                                    <br>
                                    <div class="row">
                                        <div class="col-2 text-end" style="padding-top:15px;">
                                            2部
                                        </div>
                                        <div class="col-2 text-center" style="padding-top:15px;">
                                            開場
                                        </div>
                                        <div class="col">
                                            <input type="time" class="luna-form-control" v-model="event_at_open_2" />
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-2 text-end" style="padding-top:15px;">

                                        </div>
                                        <div class="col-2 text-center" style="padding-top:15px;">
                                            開演
                                        </div>
                                        <div class="col">
                                            <input type="time" class="luna-form-control" v-model="event_at_from_2" />
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-2 text-end" style="padding-top:15px;">

                                        </div>
                                        <div class="col-2 text-center" style="padding-top:15px;">
                                            閉演
                                        </div>
                                        <div class="col">
                                            <input type="time" class="luna-form-control" v-model="event_at_to_2" />
                                        </div>
                                    </div>
                                </div>
                                <div v-show="event_type_val > 2">
                                    <br>
                                    <div class="row">
                                        <div class="col-2 text-end" style="padding-top:15px;">
                                            3部
                                        </div>
                                        <div class="col-2 text-center" style="padding-top:15px;">
                                            開場
                                        </div>
                                        <div class="col">
                                            <input type="time" class="luna-form-control" v-model="event_at_open_3" />
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-2 text-end" style="padding-top:15px;">

                                        </div>
                                        <div class="col-2 text-center" style="padding-top:15px;">
                                            開演
                                        </div>
                                        <div class="col">
                                            <input type="time" class="luna-form-control" v-model="event_at_from_3" />
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-2 text-end" style="padding-top:15px;">

                                        </div>
                                        <div class="col-2 text-center" style="padding-top:15px;">
                                            閉演
                                        </div>
                                        <div class="col">
                                            <input type="time" class="luna-form-control" v-model="event_at_to_3" />
                                        </div>
                                    </div>
                                </div>
                                <br />
                                <div>
                                    <small> 開催地域 </small>
                                </div>
                                <v-select name="area" :options="areas" v-model="area" placeholder="選択してください">
                                </v-select>
                                <br />
                                <div>
                                    <small> 開催住所 </small>
                                </div>
                                <input type="text" class="luna-form-control" v-model="address" placeholder="入力する" />
                                <br />
                                <div>
                                    <small> 会場名 </small>
                                </div>
                                <input type="text" class="luna-form-control" v-model="venue_name" placeholder="入力する" />
                                <br />
                                <div>
                                    <small> 定員・参加人数 </small>
                                </div>
                                <input type="text" inputmode="numeric" class="luna-form-control" v-model.number="member_count" placeholder="" />
                                <br />
                                <div>
                                    <small> 出演者・ゲストの登録 </small>
                                    <div style="font-size:12px;color:#999;">
                                        出演者・ゲスト名を登録すると、申込者がどの出演者・ゲスト経由で申し込むのかを登録できるようになります。
                                    </div>
                                </div>
                                <v-select name="is_player" :options="is_players" v-model="is_player" placeholder="選択してください"
                                    :onchange="setPlayerInput()">
                                </v-select>
                                <div v-show="player_type == 1">
                                    <div v-for="(player, index) in players" :key="index" style="padding-top:3px;">
                                        <div class="row">
                                            <div class="col-3 text-end" style="padding-top:15px">{{ index + 1 }}人目</div>
                                            <div class="col">
                                                <input type="text" class="luna-form-control" v-model="player.value"
                                                    placeholder="入力する" />
                                            </div>
                                            <div class="col-1 px-0 text-center" style="padding-top:12px">
                                                <svg style="height:20px;width:20px;fill:#cdcdcd;"
                                                    @click="rmPlayerInput(index)">
                                                    <use xlink:href="/images/x.svg#x"></use>
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="text-end" style="padding-top:10px;">
                                        <button type="button" class="btn btn-luna" style="padding: 3px 20px 8px 20px;"
                                            @click="addPlayerInput()" id="on-btn">
                                            <i class="bi bi-plus"
                                                style="font-size:25px;top: 4px;position: relative;"></i>出演者の追加
                                        </button>
                                    </div>
                                </div>
                                <br>
                                <div>
                                    <small> 概要 </small>
                                </div>
                                <textarea class="luna-form-control" id="event_summary" name="event_summary" rows="5"
                                    :placeholder="`こんな人に、おすすめなど（最大${this.requiredEventTextMaxLength}文字）`" v-model="event_summary"></textarea>
                                <div class="text-end" style="font-size:10px;"
                                    :class="(this.event_summary.length > this.requiredEventTextMaxLength) ? 'err_color' : 'color:#999'">
                                    {{ this.event_summary.length }}/{{ this.requiredEventTextMaxLength }}
                                </div>
                                <br />
                                <div>
                                    <small> こんな人におすすめ </small>
                                </div>
                                <textarea class="luna-form-control" id="event_recommend" name="event_recommend" rows="5"
                                    :placeholder="`こんな人に、おすすめなど（最大${this.requiredEventTextMaxLength}文字）`" v-model="event_recommend"></textarea>
                                <div class="text-end" style="font-size:10px;"
                                    :class="(this.event_recommend.length > this.requiredEventTextMaxLength) ? 'err_color' : 'color:#999'">
                                    {{ this.event_recommend.length }}/{{ this.requiredEventTextMaxLength }}
                                </div>
                                <br />
                                <div>
                                    <small> イベント詳細 </small>
                                </div>
                                <textarea class="luna-form-control" id="event_details" name="event_details" rows="5"
                                    :placeholder="`どんなイベントか、タイムスケジュールなど（最大${this.requiredEventTextMaxLength}文字）`" v-model="event_details"></textarea>
                                <div class="text-end" style="font-size:10px;"
                                    :class="(this.event_details.length > this.requiredEventTextMaxLength) ? 'err_color' : 'color:#999'">
                                    {{ this.event_details.length }}/{{ this.requiredEventTextMaxLength }}
                                </div>
                                <br />
                                <div>
                                    <small> 注意事項 </small>
                                </div>
                                <textarea class="luna-form-control" id="event_notes" name="event_notes" rows="5"
                                    :placeholder="`内容を記入する（最大${this.requiredEventTextMaxLength}文字）`" v-model="event_notes"></textarea>
                                <div class="text-end" style="font-size:10px;"
                                    :class="(this.event_notes.length > this.requiredEventTextMaxLength) ? 'err_color' : 'color:#999'">
                                    {{ this.event_notes.length }}/{{ this.requiredEventTextMaxLength }}
                                </div>
                                <br />
                                <div>
                                    <small> 決済方法・費用 </small>
                                </div>
                                <div class="row" style="padding:0 12px;">
                                    <div class="col-6 px-0">
                                        <div style="padding-right:3px;padding-bottom:6px;">
                                            <div class="luna-search-select-bar">
                                                <div class="form-check" style="padding-left:0;margin-bottom:2px;">
                                                    <input class="form-check-input-luna" type="checkbox" disabled
                                                        v-model="is_amount1"
                                                        style="width:16px;height:16px;float:none;margin-left:0;margin-top:6px;">
                                                    <label class="form-check-label"
                                                        style="font-size:10px;font-weight: bold;">
                                                        当日決済
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-6 px-0">
                                        <div style="padding-left:3px;padding-bottom:6px;">
                                            <div class="luna-search-bar">
                                                <div class="form-check" style="padding-left:0;margin-bottom:2px;">
                                                    <input class="form-check-input-luna" type="checkbox" disabled
                                                        v-model="is_amount2"
                                                        style="width:16px;height:16px;float:none;margin-left:0;margin-top:6px;">
                                                    <label class="form-check-label" style="font-size:10px;">
                                                        事前決済（後日実装）
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-show="event_type_val > 1">
                                    <div class="row" style="padding-top:10px">
                                        <div class="col-2 text-end" style="padding-top:15px;">
                                            1部
                                        </div>
                                        <div class="col-2 text-center" style="padding-top:15px;">
                                            男性
                                        </div>
                                        <div class="col">
                                            <input type="text" class="luna-form-control" v-model="amount1" />
                                        </div>
                                        <div class="col-2" style="padding-top:15px;">
                                            円
                                        </div>
                                    </div>
                                    <div class="row" style="padding-top:10px">
                                        <div class="col-2 text-end" style="padding-top:15px;">
                                        </div>
                                        <div class="col-2 text-center" style="padding-top:15px;">
                                            女性
                                        </div>
                                        <div class="col">
                                            <input type="text" class="luna-form-control" v-model="amount2" />
                                        </div>
                                        <div class="col-2" style="padding-top:15px;">
                                            円
                                        </div>
                                    </div>
                                </div>
                                <div v-show="event_type_val > 1">
                                    <div class="row" style="padding-top:10px">
                                        <div class="col-2 text-end" style="padding-top:15px;">
                                            2部
                                        </div>
                                        <div class="col-2 text-center" style="padding-top:15px;">
                                            男性
                                        </div>
                                        <div class="col">
                                            <input type="text" class="luna-form-control" v-model="amount3" />
                                        </div>
                                        <div class="col-2" style="padding-top:15px;">
                                            円
                                        </div>
                                    </div>
                                    <div class="row" style="padding-top:10px">
                                        <div class="col-2 text-end" style="padding-top:15px;">
                                        </div>
                                        <div class="col-2 text-center" style="padding-top:15px;">
                                            女性
                                        </div>
                                        <div class="col">
                                            <input type="text" class="luna-form-control" v-model="amount4" />
                                        </div>
                                        <div class="col-2" style="padding-top:15px;">
                                            円
                                        </div>
                                    </div>
                                </div>
                                <div v-show="event_type_val > 2">
                                    <div class="row" style="padding-top:10px">
                                        <div class="col-2 text-end" style="padding-top:15px;">
                                            3部
                                        </div>
                                        <div class="col-2 text-center" style="padding-top:15px;">
                                            男性
                                        </div>
                                        <div class="col">
                                            <input type="text" class="luna-form-control" v-model="amount5" />
                                        </div>
                                        <div class="col-2" style="padding-top:15px;">
                                            円
                                        </div>
                                    </div>
                                    <div class="row" style="padding-top:10px">
                                        <div class="col-2 text-end" style="padding-top:15px;">
                                        </div>
                                        <div class="col-2 text-center" style="padding-top:15px;">
                                            女性
                                        </div>
                                        <div class="col">
                                            <input type="text" class="luna-form-control" v-model="amount6" />
                                        </div>
                                        <div class="col-2" style="padding-top:15px;">
                                            円
                                        </div>
                                    </div>
                                </div>
                                <div v-show="event_type_val > 0">
                                    <div class="row" style="padding-top:10px">
                                        <div class="col-2 text-end" style="padding-top:15px;">
                                            通し
                                        </div>
                                        <div class="col-2 text-center" style="padding-top:15px;">
                                            男性
                                        </div>
                                        <div class="col">
                                            <input type="text" class="luna-form-control" v-model="amount7" />
                                        </div>
                                        <div class="col-2" style="padding-top:15px;">
                                            円
                                        </div>
                                    </div>
                                    <div class="row" style="padding-top:10px">
                                        <div class="col-2 text-end" style="padding-top:15px;">
                                        </div>
                                        <div class="col-2 text-center" style="padding-top:15px;">
                                            女性
                                        </div>
                                        <div class="col">
                                            <input type="text" class="luna-form-control" v-model="amount8" />
                                        </div>
                                        <div class="col-2" style="padding-top:15px;">
                                            円
                                        </div>
                                    </div>
                                </div>
                                <br />
                                <div>
                                    <small> チケットの設定 </small>
                                </div>
                                <div class="row" style="padding:0 12px;">
                                    <div class="col-6 px-0">
                                        <div style="padding-right:3px;padding-bottom:6px;">
                                            <div class="luna-search-select-bar">
                                                <div class="form-check" style="padding-left:0;margin-bottom:2px;">
                                                    <input class="form-check-input-luna" type="checkbox" disabled
                                                        v-model="is_amount1"
                                                        style="width:16px;height:16px;float:none;margin-left:0;margin-top:6px;">
                                                    <label class="form-check-label"
                                                        style="font-size:10px;font-weight: bold;">
                                                        先着制
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-6 px-0">
                                        <div style="padding-left:3px;padding-bottom:6px;">
                                            <div class="luna-search-bar">
                                                <div class="form-check" style="padding-left:0;margin-bottom:2px;">
                                                    <input class="form-check-input-luna" type="checkbox" disabled
                                                        v-model="is_amount2"
                                                        style="width:16px;height:16px;float:none;margin-left:0;margin-top:6px;">
                                                    <label class="form-check-label" style="font-size:10px;">
                                                        抽選制（後日実装）
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <br>
                                <div>
                                    <small> お問い合わせ先メールアドレス </small>
                                </div>
                                <input type="text" class="luna-form-control" v-model="customer_mail" placeholder="入力する" />
                            </div>
                        </div>
                    </div>
                    <br>
                    <div class="row" style="background:#E7E7FF">
                        <div class="col">
                            <div style="padding:30px 0;">
                                <div>
                                    <small> 公開状態を選択 </small>
                                </div>
                                <v-select name="open_status" :options="open_status_list" v-model="open_status"
                                    placeholder="選択してください" :disabled="event.is_read_only">
                                </v-select>
                                <div v-if="!event.is_read_only" style="padding-top:15px;">
                                    <div class="row justify-content-center">
                                        <div class="col-9">
                                            <br />
                                            <div class="d-grid gap-2">
                                                <button type="button" class="btn btn-luna disabled" style="padding: 12px 0"
                                                    v-if="is_load">
                                                    <div class="spinner-border" style="width: 1rem; height: 1rem;"
                                                        role="status" v-if="is_load">
                                                        <span class="visually-hidden">Loading...</span>
                                                    </div>
                                                    保存する
                                                </button>
                                                <button type="button" class="btn btn-luna" style="padding: 12px 0"
                                                    @click="setEvent()" id="on-btn" v-else-if="isEventNext()">
                                                    保存する
                                                </button>
                                                <button type="button" class="btn btn-luna-d disabled"
                                                    style="padding: 12px 0" id="non-btn" v-else>
                                                    保存する
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br />
                    <div class="row">
                        <div class="col text-end">
                            <a v-if="!event.is_read_only" type="button" class="btn btn-luna-outline" :href="'/event/admin/rm/' + event.id"
                                style="padding:8px 12px;border-radius: 10px;font-size:14px">
                                削除する
                            </a>
                        </div>
                    </div>
                    <br>
                    <br>
                    <br>
                    <br>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { hasValidRequiredEventTexts, isBlank, normalizeRequiredEventTextFields, normalizeText, REQUIRED_EVENT_TEXT_MAX_LENGTH } from "../../../helpers/eventText";

export default {
    data() {
        return {
            event: {},
            event_player_member: {},

            address: "",
            amount1: "",
            amount2: "",
            amount3: "",
            amount4: "",
            amount5: "",
            amount6: "",
            amount7: "",
            amount8: "",
            area: null,

            event_at_from_1: null,
            event_at_from_2: null,
            event_at_from_3: null,
            event_at_open_1: null,
            event_at_open_2: null,
            event_at_open_3: null,
            event_at_to_1: null,
            event_at_to_2: null,
            event_at_to_3: null,
            event_at: null,
            event_details: "",
            event_feature: "",
            event_notes: "",
            event_recommend: "",
            event_summary: "",
            event_type_val: 0,
            event_type: [],
            is_amount1: true,
            is_amount2: false,
            is_load: false,
            is_player: [],
            member_count: 0,
            myCroppa: {},
            organizer: "",
            venue_name: "",
            player_type: 0,
            players: [],
            thumbnail: "",
            url: "",

            customer_mail: "",
            requiredEventTextMaxLength: REQUIRED_EVENT_TEXT_MAX_LENGTH,

            is_player: null,
            is_players: [
                { value: "0", label: "なし" },
                { value: "1", label: "あり" },
            ],

            event_types: [
                { value: "0", label: "1部制" },
                { value: "1", label: "2部制" },
                { value: "2", label: "3部制" },
            ],

            areas: [
                { value: "北海道", label: "北海道" },
                { value: "青森県", label: "青森県" },
                { value: "岩手県", label: "岩手県" },
                { value: "宮城県", label: "宮城県" },
                { value: "秋田県", label: "秋田県" },
                { value: "山形県", label: "山形県" },
                { value: "福島県", label: "福島県" },
                { value: "茨城県", label: "茨城県" },
                { value: "栃木県", label: "栃木県" },
                { value: "群馬県", label: "群馬県" },
                { value: "埼玉県", label: "埼玉県" },
                { value: "千葉県", label: "千葉県" },
                { value: "東京都", label: "東京都" },
                { value: "神奈川県", label: "神奈川県" },
                { value: "新潟県", label: "新潟県" },
                { value: "富山県", label: "富山県" },
                { value: "石川県", label: "石川県" },
                { value: "福井県", label: "福井県" },
                { value: "山梨県", label: "山梨県" },
                { value: "長野県", label: "長野県" },
                { value: "岐阜県", label: "岐阜県" },
                { value: "静岡県", label: "静岡県" },
                { value: "愛知県", label: "愛知県" },
                { value: "三重県", label: "三重県" },
                { value: "滋賀県", label: "滋賀県" },
                { value: "京都府", label: "京都府" },
                { value: "大阪府", label: "大阪府" },
                { value: "兵庫県", label: "兵庫県" },
                { value: "奈良県", label: "奈良県" },
                { value: "和歌山県", label: "和歌山県" },
                { value: "鳥取県", label: "鳥取県" },
                { value: "島根県", label: "島根県" },
                { value: "岡山県", label: "岡山県" },
                { value: "広島県", label: "広島県" },
                { value: "山口県", label: "山口県" },
                { value: "徳島県", label: "徳島県" },
                { value: "香川県", label: "香川県" },
                { value: "愛媛県", label: "愛媛県" },
                { value: "高知県", label: "高知県" },
                { value: "福岡県", label: "福岡県" },
                { value: "佐賀県", label: "佐賀県" },
                { value: "長崎県", label: "長崎県" },
                { value: "熊本県", label: "熊本県" },
                { value: "大分県", label: "大分県" },
                { value: "宮崎県", label: "宮崎県" },
                { value: "鹿児島県", label: "鹿児島県" },
                { value: "沖縄県", label: "沖縄県" },
                { value: "オンライン", label: "オンライン" },
            ],

            initialImage: null,

            open_status: [],

            open_status_list: [
                { value: "0", label: "非公開" },
                { value: "1", label: "受付準備中で公開" },
                { value: "2", label: "募集中で公開" },
                { value: "3", label: "申込締切で公開" },
            ],

            im: '',
        };
    },
    methods: {
        setEventTypeVal() {
            if (this.event_type == null) {
                this.event_type_val = 0
            }
            else {
                this.event_type_val = Number(this.event_type.value) + 1
            }
        },
        onFileTypeMismatch(file) {
            alert('jpg, gif, png　形式でアップして下さい。')
        },
        setPlayerInput() {
            if (this.is_player == null) {
                this.player_type = 0
            }
            else if (this.is_player.value == 0) {
                this.player_type = 0
            }
            else if (this.is_player.value == 1) {
                this.player_type = 1
            }

            if (this.players.length == 0) {
                let player = { value: "" }
                this.players.push(player)
            }
        },
        addPlayerInput() {
            let player = { value: "" }
            this.players.push(player)
        },
        rmPlayerInput(index) {
            this.players.splice(index, 1)
        },
        async setEvent() {
            if (this.event.is_read_only) {
                return;
            }
            this.is_load = true

            if (!this.isEventNext()) {
                this.is_load = false
                this.$showErrorToast("入力内容を確認してください")
                return
            }

            let event_to_time = null
            const eventTexts = normalizeRequiredEventTextFields({
                event_details: this.event_details,
                event_recommend: this.event_recommend,
                event_summary: this.event_summary,
                event_notes: this.event_notes,
            })
            const thumbnail = normalizeText(this.thumbnail)
            const organizer = normalizeText(this.organizer)
            const venueName = normalizeText(this.venue_name)
            const address = normalizeText(this.address)
            const eventFeature = normalizeText(this.event_feature)
            const customerMail = normalizeText(this.customer_mail)

            if (this.event_type.value == 0) {
                event_to_time = this.event_at_to_1
            }
            else if (this.event_type.value == 1) {
                event_to_time = this.event_at_to_2
            }
            else if (this.event_type.value == 2) {
                event_to_time = this.event_at_to_3
            }

            let is_image = true
            let img_file = null
            if (this.myCroppa == null) {
                is_image = false
            }
            else if (!(this.myCroppa.generateDataUrl() != '')) {
                is_image = false
            }
            else {
                img_file = this.myCroppa.generateDataUrl()
            }

            await axios
                .post("/api/event/mod/" + this.$route.params['eid'], {
                    thumbnail: thumbnail,
                    event_at_from: this.event_at + ' ' + this.event_at_from_1 + ':00',
                    event_at_to: this.event_at + ' ' + event_to_time + ':00',
                    event_at_from_1: this.event_at + ' ' + this.event_at_from_1 + ':00',
                    event_at_to_1: this.event_at + ' ' + this.event_at_to_1 + ':00',
                    event_at_open_1: this.event_at + ' ' + this.event_at_open_1 + ':00',
                    event_at_from_2: this.event_at + ' ' + this.event_at_from_2 + ':00',
                    event_at_to_2: this.event_at + ' ' + this.event_at_to_2 + ':00',
                    event_at_open_2: this.event_at + ' ' + this.event_at_open_2 + ':00',
                    event_at_from_3: this.event_at + ' ' + this.event_at_from_3 + ':00',
                    event_at_to_3: this.event_at + ' ' + this.event_at_to_3 + ':00',
                    event_at_open_3: this.event_at + ' ' + this.event_at_open_3 + ':00',
                    recruit_at_from: null,
                    recruit_at_to: null,
                    member_count: this.member_count,
                    address: address,
                    organizer: organizer,
                    venue_name: venueName,

                    amount2: 0,
                    amount1: 0,
                    amount4: this.amount7,
                    amount3: this.amount8,
                    amount6: null,
                    amount5: null,
                    amount8: this.amount1,
                    amount7: this.amount2,
                    amount10: null,
                    amount9: null,
                    amount12: this.amount3,
                    amount11: this.amount4,
                    amount14: null,
                    amount13: null,
                    amount16: this.amount5,
                    amount15: this.amount6,
                    amount18: null,
                    amount17: null,
                    amount19: this.amount8,
                    amount20: this.amount7,

                    event_type: this.event_type.value,
                    ...eventTexts,
                    event_feature: eventFeature,
                    address_view: (this.area == null) ? "" : this.area.value,
                    catch_copy: '',
                    customer_mail: customerMail,

                    img_url: img_file,
                    is_image: is_image,

                    open_status: this.open_status.value
                })
                .then((response) => {
                    window.location.href = "/event/home"
                })
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        //window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("イベントの編集に失敗しました")
                    }
                }).finally(() => {
                    this.is_load = false
                })
        },
        async isAuth() {
            await axios.get("/api/auth/user/get")
                .then(
                    (response) => {
                        this.fetchEvent(this.$route.params['eid'])
                    }
                )
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("ユーザーの取得に失敗しました")
                    }
                })
        },
        async fetchEvent(eid) {
            await axios.get("/api/event/admin/get/" + eid)
                .then(
                    (response) => {
                        this.event = response.data.event || {}
                        this.event_player_member = Array.isArray(response.data.event_player_member)
                            ? response.data.event_player_member
                            : []

                        var image = new Image()
                        // Notice: it's necessary to set "crossorigin" attribute before "src" attribute.
                        image.setAttribute('crossorigin', 'anonymous')
                        image.src = this.event.img_url

                        this.initialImage = this.event.img_url || null
                        //this.myCroppa.refresh()

                        this.thumbnail = this.event.thumbnail ?? ""
                        this.organizer = this.event.organizer ?? ""
                        this.venue_name = this.event.venue_name ?? ""
                        this.event_at = this.event.event_at ?? null

                        this.address = this.event.address ?? ""
                        this.member_count = this.event.member_count ?? 0
                        this.event_summary = this.event.event_summary ?? ""
                        this.event_recommend = this.event.event_recommend ?? ""
                        this.event_details = this.event.event_details ?? ""
                        this.event_notes = this.event.event_notes ?? ""


                        let _event_type = (this.event.event_type == null) ? null : this.event_types[this.event.event_type];
                        this.event_type = _event_type

                        this.event_at_open_1 = this.getTime(this.event.event_at_open_1)
                        this.event_at_from_1 = this.getTime(this.event.event_at_from_1)
                        this.event_at_to_1 = this.getTime(this.event.event_at_to_1)
                        this.event_at_open_2 = this.getTime(this.event.event_at_open_2)
                        this.event_at_from_2 = this.getTime(this.event.event_at_from_2)
                        this.event_at_to_2 = this.getTime(this.event.event_at_to_2)
                        this.event_at_open_3 = this.getTime(this.event.event_at_open_3)
                        this.event_at_from_3 = this.getTime(this.event.event_at_from_3)
                        this.event_at_to_3 = this.getTime(this.event.event_at_to_3)

                        let _address_view = (this.event.address_view == null) ? null : { value: this.event.address_view, label: this.event.address_view };
                        this.area = _address_view

                        this.amount1 = this.event.amount8 ?? ""
                        this.amount2 = this.event.amount7 ?? ""
                        this.amount3 = this.event.amount12 ?? ""
                        this.amount4 = this.event.amount11 ?? ""
                        this.amount5 = this.event.amount16 ?? ""
                        this.amount6 = this.event.amount15 ?? ""
                        this.amount7 = this.event.amount20 ?? ""
                        this.amount8 = this.event.amount19 ?? ""

                        this.customer_mail = this.event.customer_mail ?? ""

                        this.open_status = this.open_status_list[this.event.open_status]

                        this.is_player = this.is_players[this.event.is_player]
                        this.player_type = this.event.is_player

                        let p = []
                        this.event_player_member.forEach(function (player) {
                            p.push({ value: player.player_name })
                        })

                        this.players = p

                        if (this.event.is_open == false) {
                            this.open_status = { value: "0", label: "非公開" }
                        }
                        else if (this.event.is_open == true && this.event.is_preparation == true && this.event.is_recruiting == false) {
                            this.open_status = { value: "1", label: "受付準備中で公開" }
                        }
                        else if (this.event.is_open == true && this.event.is_preparation == false && this.event.is_recruiting == true) {
                            this.open_status = { value: "2", label: "募集中で公開" }
                        }
                        else if (this.event.is_open == true && this.event.is_preparation == false && this.event.is_recruiting == false) {
                            this.open_status = { value: "3", label: "申込締切で公開" }
                        }
                        else {
                            this.open_status = { value: "0", label: "非公開" }
                        }
                    }
                )
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("イベントの取得に失敗しました")
                    }
                })
        },
        getTime(time) {
            if (!time || typeof time !== 'string') {
                return null
            }

            let chunks = time.split(' ')
            if (chunks.length < 2) {
                return null
            }

            let hm = chunks[1].split(':')
            if (hm.length < 2) {
                return null
            }

            return hm[0] + ':' + hm[1]
        },
        isEventNext() {

            if (isBlank(this.thumbnail)) {
                return false
            }

            if (isBlank(this.event_at)) {
                return false
            }

            if (this.event_type == null || isBlank(this.event_type.value)) {
                return false
            }
            else if (this.event_type != null) {

                if (this.event_type.value == 0) {
                    if (this.event_at_from_1 == null) {

                        return false
                    }
                    else if (this.event_at_from_1 == '') {
                        return false
                    }

                    if (this.event_at_open_1 == null) {
                        return false
                    }
                    else if (this.event_at_open_1 == '') {
                        return false
                    }
                    if (this.event_at_to_1 == null) {
                        return false
                    }
                    else if (this.event_at_to_1 == '') {
                        return false
                    }
                }
                else if (this.event_type.value == 1) {

                    if (this.event_at_from_1 == null) {
                        return false
                    }
                    else if (this.event_at_from_1 == '') {
                        return false
                    }

                    if (this.event_at_open_1 == null) {
                        return false
                    }
                    else if (this.event_at_open_1 == '') {
                        return false
                    }
                    if (this.event_at_to_1 == null) {
                        return false
                    }
                    else if (this.event_at_to_1 == '') {
                        return false
                    }

                    if (this.event_at_from_2 == null) {
                        return false
                    }
                    else if (this.event_at_from_2 == '') {
                        return false
                    }

                    if (this.event_at_open_2 == null) {
                        return false
                    }
                    else if (this.event_at_open_2 == '') {
                        return false
                    }
                    if (this.event_at_to_2 == null) {
                        return false
                    }
                    else if (this.event_at_to_2 == '') {
                        return false
                    }
                }
                else if (this.event_type.value == 2) {

                    if (this.event_at_from_1 == null) {
                        return false
                    }
                    else if (this.event_at_from_1 == '') {
                        return false
                    }

                    if (this.event_at_open_1 == null) {
                        return false
                    }
                    else if (this.event_at_open_1 == '') {
                        return false
                    }
                    if (this.event_at_to_1 == null) {
                        return false
                    }
                    else if (this.event_at_to_1 == '') {
                        return false
                    }

                    if (this.event_at_from_2 == null) {
                        return false
                    }
                    else if (this.event_at_from_2 == '') {
                        return false
                    }

                    if (this.event_at_open_2 == null) {
                        return false
                    }
                    else if (this.event_at_open_2 == '') {
                        return false
                    }
                    if (this.event_at_to_2 == null) {
                        return false
                    }
                    else if (this.event_at_to_2 == '') {
                        return false
                    }

                    if (this.event_at_from_3 == null) {
                        return false
                    }
                    else if (this.event_at_from_3 == '') {
                        return false
                    }

                    if (this.event_at_open_3 == null) {
                        return false
                    }
                    else if (this.event_at_open_3 == '') {
                        return false
                    }
                    if (this.event_at_to_3 == null) {
                        return false
                    }
                    else if (this.event_at_to_3 == '') {
                        return false
                    }
                }
            }
            /*             if (this.is_player == null) {
                            return false
                        }
                        else if (this.is_player.length == 0) {
                            return false
                        }
             */

            if (isBlank(this.address)) {
                return false
            }

            if (this.area == null || isBlank(this.area.value)) {
                return false
            }

            if (this.member_count < 1) {
                return false
            }

            if (isBlank(this.organizer)) {
                return false
            }

            /*             if (!(this.myCroppa.generateDataUrl() != '')) {
                            return false
                        } */

            const eventTexts = normalizeRequiredEventTextFields({
                event_details: this.event_details,
                event_recommend: this.event_recommend,
                event_summary: this.event_summary,
                event_notes: this.event_notes,
            })

            if (!hasValidRequiredEventTexts(eventTexts)) {
                return false
            }
            if (this.event_type_val == 1) {
                if (isBlank(this.amount7)) {
                    return false
                }
                if (isBlank(this.amount8)) {
                    return false
                }
            }
            else if (this.event_type_val == 2) {

                if (isBlank(this.amount1)) {
                    return false
                }
                if (isBlank(this.amount2)) {
                    return false
                }

                if (isBlank(this.amount3)) {
                    return false
                }
                if (isBlank(this.amount4)) {
                    return false
                }

                if (isBlank(this.amount7)) {
                    return false
                }
                if (isBlank(this.amount8)) {
                    return false
                }
            }
            else if (this.event_type_val == 3) {

                if (isBlank(this.amount1)) {
                    return false
                }
                if (isBlank(this.amount2)) {
                    return false
                }

                if (isBlank(this.amount3)) {
                    return false
                }
                if (isBlank(this.amount4)) {
                    return false
                }

                if (isBlank(this.amount5)) {
                    return false
                }
                if (isBlank(this.amount6)) {
                    return false
                }

                if (isBlank(this.amount7)) {
                    return false
                }
                if (isBlank(this.amount8)) {
                    return false
                }
            }

            //メールアドレスとして判定される文字列と記号の組み合わせを定数化
            const reg = new RegExp(/^[A-Za-z0-9]{1}[A-Za-z0-9_.+-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/);
            //指定した組み合わせになっていなかった場合判定を返す。

            if (!reg.test(this.customer_mail)) {
                return false
            }


            return true
        },
    },
    async created() {

        // 自動ログインチェック
        var arr = new Array();
        if (document.cookie != '') {
            var tmp = document.cookie.split('; ');
            for (var i = 0; i < tmp.length; i++) {
                var data = tmp[i].split('=');
                arr[data[0]] = decodeURIComponent(data[1]);
            }

            if (arr['uid'] != undefined) {
                await axios.get("/api/user/auth/" + arr['uid'])
                    .then(
                        (response) => {
                            this.isAuth()
                            this.im = Date.now()
                        })
                    .catch((error) => {
                        this.$showErrorToast("ユーザーの取得に失敗しました")
                    })
            }
            else {
                this.isAuth()
                this.im = Date.now()
            }
        }
        else {
            this.isAuth()
            this.im = Date.now()
        }
    },
};
</script>

<style scoped>
small {
    color: #5538EE;
}

.select_sex {
    border: 0px;
}

.vs__dropdown-toggle {
    border-top: 0px;
    border-right: 0px;
    border-left: 0px;
    border-bottom: 1px solid #ced4da;
    border-radius: 0;
}

.vs__selected-options {
    color: #cdcfd0;
}

.sub_windows {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 111;
}

.croppa-container {
    background-color: #fff;
    border-radius: 8px;
}

.footer_event_after_box {
    background-color: #cdcdcd;
    color: #999;
    font-size: 14px;
    padding-top: 10px;
    padding-bottom: 10px;
}

.footer_event_befor_box {
    background-color: #C6C4FF;
    color: #6B4EFF;
    font-size: 14px;
    padding-top: 10px;
    padding-bottom: 10px;
}

.footer_event_now_box {
    background-color: #6B4EFF;
    color: #fff;
    font-size: 14px;
    padding-top: 10px;
    padding-bottom: 10px;
}

.luna-header-box {
    box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.1);
    height: 56px;
    width: 540px;
    background-color: #fff;
    z-index: 999;
}


@media (max-width: 576px) {
    .luna-header-box {
        width: 100%;
    }
}

.luna-search-bar {
    padding: 8px 12px 10px 12px;
    background-color: #fff;
    border-radius: 5px;
    color: #333333;
    border: 1px solid #E6E6E6;
}


.luna-search-select-bar {
    padding: 8px 12px 10px 12px;
    background-color: #f0f0ff;
    border-radius: 5px;
    color: #000000;
}
</style>
